module.exports = __webpack_public_path__ + "static/img/file-html.04506464.svg";